import { render, staticRenderFns } from "./index--data.vue?vue&type=template&id=9b812fd6&"
import script from "./index--data.vue?vue&type=script&lang=js&"
export * from "./index--data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports